import React from "react";
import Map from "./Map";
import Alerts from "./Alerts";
import Success from "./Success";
import Nav from "./Nav";
import Footer from "./Footer";
import Loading from "./Loading";
import Invoicing from "./invoicing";
export default class App extends React.Component{
    render() {
    return (
        <div className={"main-container"}>
            <Nav/>
            <div className="app-name">
                <Map/>
                <Alerts/>
                <Success/>
                <Loading/>
                <Invoicing/>
            </div>
            <Footer/>
        </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/App.js